module.exports = __webpack_public_path__ + "img/Q1.93031aaf.jpg";